import { Arg, Metadata } from '../../../utils/spds/metadata';
import {
  MODAL_DOCS_STANDARD_BLOCKS,
  assembleModalDescription,
} from '../../../utils/spds/metadata/modal-docs';
import { applyPanelAccessibleName } from '../../../utils/spds/accessible-name';
import { hash } from '@ember/helper';
import FlexColumn from '../layout/flex/column.gjs';
import StandardBody from './standard/body.gjs';
import StandardFooter from './standard/footer.gjs';
import StandardHeader from './standard/header.gjs';
import Super from '../core/modal.gjs';
import styles from './standard.module.scss';

const METADATA = Metadata.define({
  description: assembleModalDescription(
    'Basic design system modal with limited built-in configuration.',
    MODAL_DOCS_STANDARD_BLOCKS
  ),
  meta: {
    ariaLabel: Arg.string({
      description:
        'Accessible name for the modal. Only needed when the yielded `Header` block is omitted, since the header title supplies the name otherwise',
    }),
  },
  name: 'Standard',
  resources: {
    figma:
      'https://www.figma.com/design/g4zf0Vkj39VcCyleokv2rl/%E2%9D%96-Air-web-components?node-id=25680-18273&m=dev',
    zeroheight: 'https://www.simplepractice.design/1d0abbc0a/p/380570-modal',
  },
});

export default class SpdsModalStandard extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal';
  modal = true;
  styles = styles;

  get bodyId() {
    return this.composeSubcomponentId('body');
  }

  get footerId() {
    return this.composeSubcomponentId('footer');
  }

  get headerId() {
    return this.composeSubcomponentId('header');
  }

  get headerTitleId() {
    return this.composeSubcomponentId('header-title');
  }

  /**
   * Names the dialog once the yielded chrome is in the DOM. The dialog's own listeners and the
   * open sequence come first, so `super.setup()` runs before this.
   */
  setup() {
    super.setup();

    applyPanelAccessibleName(this, 'spds.modal.standard.missing-accessible-name');
  }

  <template>
    <FlexColumn
      @fixed={{true}}
      @id={{this.id}}
      @tag="dialog"
      aria-label={{@ariaLabel}}
      class={{this.classes}}
      data-test-spds-modal
      ...attributes
      {{this.setupComponent}}
    >
      {{yield
        (hash
          Body=(component StandardBody id=this.bodyId titleId=this.headerTitleId)
          Footer=(component StandardFooter id=this.footerId)
          Header=(component
            StandardHeader close=this.beforeClose id=this.headerId titleId=this.headerTitleId
          )
          beforeClose=this.beforeClose
          close=this.close
          titleId=this.headerTitleId
        )
      }}
    </FlexColumn>
  </template>
}

export const MODAL_STANDARD_METADATA = SpdsModalStandard.metadata;
